import React from 'react'
import { Control, FieldErrors } from 'react-hook-form'
import DiagnosisSelect from './diagnosis-select'
import { SelectOption } from './diagnosis-select'

interface DiagnosisSelectWrapperProps {
  question: {
    id: number | string
    text: string
    isRequired?: boolean
    type: string
    component?: string
  }
  // RHF mode
  field?: {
    value: any
    onChange: (value: any) => void
    onBlur: () => void
  }
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: string
  error?: string
  onChange?: (value: string | null) => void
  // Shared props
  clientId?: number
  responseByQuestionId?: Record<number, any>
  allQuestions?: Array<{ id: number | string }>
}

const DiagnosisSelectWrapper: React.FC<DiagnosisSelectWrapperProps> = ({
  field,
  value: zustandValue,
  onChange: zustandOnChange,
}) => {
  const isRHFMode = !!field

  // Parse the stored value (comma-separated string of diagnosis codes)
  // DiagnosisSelect expects an array of strings (codes)
  const parseValue = (value: string | undefined): string[] => {
    if (!value) return []
    // Split by comma and filter out empty strings
    return value
      .split(',')
      .filter(Boolean)
      .filter(code => code !== 'OTHER')
  }

  // Format the value for storage (comma-separated string)
  const formatValue = (diagnoses: SelectOption[]): string => {
    if (!diagnoses || diagnoses.length === 0) return ''
    return diagnoses.map(d => d.value).join(',')
  }

  const currentValue = parseValue(isRHFMode ? field.value : zustandValue)

  const handleChange = (diagnoses: SelectOption[] | null) => {
    // Store as comma-separated string of diagnosis codes
    const formattedValue = diagnoses ? formatValue(diagnoses) : ''
    const valueToStore = formattedValue || null
    if (isRHFMode) {
      field.onChange(valueToStore)
    } else {
      zustandOnChange?.(valueToStore)
    }
  }

  return (
    <DiagnosisSelect
      onChange={handleChange}
      value={currentValue}
      shouldLimitMultiValue={false}
    />
  )
}

export default DiagnosisSelectWrapper
